
export default {
  props:{
     value:Boolean
    },
  emits: ["update:value"],
  mounted(){
  }
}
